import palette from 'Theme/palette'

const gradients = {
  publicBackground: `linear-gradient(161.81deg, ${palette.cyanCornflowerBlue} -0.85%, ${palette.prussianBlue} 93.33%)`,
  imageOverlay: {
    primary: `linear-gradient(236deg, rgba(0, 0, 0, 0) 28.205128205128204%, rgba(79, 191, 240, 0.6) 87.6923076923077%)`,
  },
}

export default gradients
